// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    DiscussionSubCategory,
    DiscussionSubCategoryFromJSON,
    DiscussionSubCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2003
     */
    next?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2003
     */
    previous?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003
     */
    count: number;
    /**
     * 
     * @type {Array<DiscussionSubCategory>}
     * @memberof InlineResponse2003
     */
    results: Array<DiscussionSubCategory>;
}

export function InlineResponse2003FromJSON(json: any): InlineResponse2003 {
    return {
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'count': json['count'],
        'results': (json['results'] as Array<any>).map(DiscussionSubCategoryFromJSON),
    };
}

export function InlineResponse2003ToJSON(value?: InlineResponse2003): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'next': value.next,
        'previous': value.previous,
        'count': value.count,
        'results': (value.results as Array<any>).map(DiscussionSubCategoryToJSON),
    };
}


